import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import tr from '../../../libs/tr';
import './AllMovPnl.css';
import FullViewBar from "./FullViewBar";
import { getLastSkierMovements } from '../../../libs/fetch'
import Cookies from 'universal-cookie';
let cookies = new Cookies;



class AllMovPnl extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Alertff: false,
            movements: [],
        };

        this.textname = props.lastName ? props.lastName : "Text missing!";

        this.onClick = this.onClick.bind(this);
    }


    componentDidMount() {
        this.getLastSkierMovements();
    }


    getLastSkierMovements = () => {
        // this.setState({ isLoading: true });
        let access_token = cookies.get('access_token');
        let params = {};
        console.log("[AllMovPnl] getLastSkierMovements ", access_token);

        getLastSkierMovements(this, access_token, params)
            .then((response) => {
                // this.setState({ isLoading: false });
                console.log("[AllMovPnl] getLastSkierMovements @response: ", response);
                if (response) {
                    this.setState({ movements: response });
                }
            });
    }

    onClick = () => {
        this.props.onClick();
    }

    renderMovementDetails = (that) => {

        // MOCKUP!
        let movements = [];
        // let movements = [];

        for (let index = 0; index < that.state.movements.length; index++) {
            const element = that.state.movements[index];
            let date = element.data.split(' ')[0];
            let movement = {
                date: date.split('-')[2] + '/' + date.split('-')[1] + '/' + date.split('-')[0],
                fullname: element.servizio,
                skiresort: 'Good Place',
                cost: element.importo,
                duration: '12:00:01',
                Cardtypelast: 'Skipass Adult',
            };
            movements.push(movement);
        }
        // let movement = {
        //     date: '29/02/2019',
        //     fullname: 'John Doe',
        //     skiresort: 'Good Place',
        //     cost: '12',
        //     duration: '12:00:01',
        //     Cardtypelast: 'Skipass Adult',


        //     // comprensorio: "Folgarida - Marilleva",
        //     // dateFrom: "2018-03-29 09:24:49",
        //     // dtrateTo: "2018-03-29",
        //     // descrizione: "Description",
        //     // paid: 0,
        //     // val_accesso: 0
        // };
        // // mockup purpuose only
        // for (let i = 0; i < 5; i++) {
        //     console.log(movement);
        //     movements.push(movement);
        // }

        // TODO CALL ALLMOVEMENTS API
        // then thake response and loop to render details
        if (movements.length == 0)
            return (
                <div className="sn_ua__container text-center">{tr.t("NoMovement")}</div>
            )
        return movements.map(function (movement, index) {
            console.log(" render movments", movement);
            return <FullViewBar
                allMovements={true}
                key={index}
                index={index}
                movement={movement}
            // textlast={movement.comprensorio} 
            />
        });
    }

    // TODO
    // move this functions to utils.js

    // @return array w/ keys of json
    jsonKeysToArray = (json) => {
        let array = [];

        Object.keys(json).forEach(function (key) {
            array.push(key);
        });

        return array;
    }


    render() {
        return (
            // <div className="containerAllmovmainPnl" style={{ flex: 1 }}>
            //     <div className="allmovfullName" style={{ flex: 1 }}>
            //         {tr.t("Seeall")}
            //     </div>
            //     <div>
            //         <button className="arrowbfBtn" onClick={this.onClick}></button>
            //         {this.state.movements && <div className={this.state.movements.length != 0 ? "fullViewfullPnl" : ''} style={{ flex: 1 }}>
            //             {this.renderMovementDetails(this)}
            //         </div>}
            //         {this.state.Alertff ?
            //             <div>
            //                 <button className="bbtnfvf">{tr.t("Retrypayment")}</button>
            //             </div> : null
            //         }
            //     </div>
            // </div>
            

		<div className="row">
			<div className="col-12 d-flex align-items-center">
				<button className="arrowbfBtn mr-2" onClick={this.onClick}></button>
					<div className="allmovfullName">
						{tr.t("Seeall")}
					</div>
				</div>
				<div className="col-12 d-flex justify-content-center">
					<div className="sn_message text-center w-100">
						{
							this.state.movements && <div className={this.state.movements.length != 0 ? "sn_ua__container py-5 px-3 p-md-5" : 'mb-5'}>
							{this.renderMovementDetails(this)}
							</div>
						}
						{
							this.state.Alertff ?
							<div className="d-flex justify-content-center">
								<button className="bbtnfvf btnFit">{tr.t("Retrypayment")}</button>
							</div> : null
						}
				</div>
			</div>
		</div>
		);
	}
}

export default AllMovPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/AllMovPnl.js